import { render, staticRenderFns } from "./dyo_photo.vue?vue&type=template&id=484a75e5&scoped=true"
import script from "./dyo_photo.vue?vue&type=script&lang=js"
export * from "./dyo_photo.vue?vue&type=script&lang=js"
import style0 from "./dyo_photo.vue?vue&type=style&index=0&id=484a75e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484a75e5",
  null
  
)

export default component.exports